<template>
    <div>
        <quill-editor v-model="value"
			:options="editorOption"
			ref="myQuillEditor"
			:id="id"
			:key="id"
			:instanceName="id">
		</quill-editor>
    </div>
    
</template>

<script scoped>
	import { quillEditor } from 'vue-quill-editor';
	export default {
		props: ['id', 'data'],
		components: {
			quillEditor
		},
		data () {
			return {
				value: this.data,
				editorOption: {
					modules: {
						toolbar: false
					}
				},
				display: 'none'
			}
		},
		methods: {

		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		mounted() {
			this.editor.enable(false);
		}
	}    
</script>

<style scoped>
	.ql-container.ql-snow {
		border: 0px;
	}
</style>
